// DisabledConfigureCat.js

const DisabledConfigureCat = [
    "PPT",
    "LID",
    "XMP",
    "XMW",
    "ANC",
    "GJM",
    "HCN",
    "MHO",
    "PBR",
    "XCN",
    "SRC",
    "SRN",
    "RLR",
    "USQ",
    "TBX"
];

export default DisabledConfigureCat;